<template>
	<div v-loading.fullscreen.lock="fullscreenLoading" element-loading-background="rgba(122, 122, 122, 0.5)" v-if="$store.state.activateStatus">
		<div class="ld-panel-title">
			<h2 class="back-btn">实例列表</h2>
		</div>
		<div class="ld-panel-main">
			<el-button type="primary" @click="buyClick">购买实例</el-button>
			<div class="input-select" style="margin-left: 12px;">
				<el-input
				  v-model="searchInput"
				  placeholder="请输入搜索关键词..."
				  class="input-with-select"
				  clearable 
				  @clear="handleEmpty"
				  style="width: 400px;"
				>
				  <template #prepend>
					<el-select v-model="searchStatus" style="width: 100px">
						<el-option label="全部" value="" />
						<el-option label="待支付" value="待支付" />
						<el-option label="待创建" value="待创建" />
						<el-option label="创建中" value="创建中" />
						<el-option label="运行中" value="运行中" />
						<el-option label="安装失败" value="安装失败" />
						<el-option label="创建超时" value="创建超时" />
						<el-option label="运行异常" value="运行异常" />
						<el-option label="已删除" value="已删除" />
						<el-option label="已关机" value="已关机" />
					</el-select>
				  </template>
				  <template #append>
					  <el-button @click="searchClick"></el-button>
				  </template>
				</el-input>
			</div>
			<div class="head-config">
				<span class="settings" @click="dialogtableHeadVisible = true"></span>
				<span class="reload" @click="reloadChange"></span>
			</div>
			<el-table :data="tableData" v-loading="loading" style="width: 100%">
				<el-table-column prop="instance_id" label="实例ID" width="140" show-overflow-tooltip v-if="tableHeadObject.tableColumn1" />
				<el-table-column label="实例名称" v-if="tableHeadObject.tableColumn2">
					<template #default="scope">
						<el-text type="primary" v-if="scope.row.status == '运行中'" @click="rowOperation(scope.row,'detail')" style="cursor: pointer;">{{scope.row.instance_name}}</el-text>
						<el-text type="primary" v-else>{{scope.row.instance_name}}</el-text>
					</template>
				</el-table-column>
				<el-table-column label="监控" width="80" v-if="tableHeadObject.tableColumn3">
					<template #default="scope">
						<span v-if="scope.row.status == '运行中'" @click="rowOperation(scope.row,'detail')" class="monitor"></span>
						<span v-else class="monitor"></span>
					</template>
				</el-table-column>
				<el-table-column label="IP地址" v-if="tableHeadObject.tableColumn4" width="220">
					<template #default="scope">
						<span :style="scope.row.status == '已删除' ? 'text-decoration: line-through; color:#999':''">{{scope.row.ip}}:{{scope.row.port}}</span>
						<div>
							<el-text type="primary" v-if="scope.row.enable_public_network == 0" @click="rowOperation(scope.row,'detail')" style="cursor: pointer;">未开通外网连接</el-text>
							<p v-if="scope.row.enable_public_network == 2">{{ scope.row.remote_domain_name }}:{{ scope.row.remote_port }}</p>
							<el-tag v-if="scope.row.enable_public_network == 3">外网连接开通中</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="开始时间/结束时间" width="160" v-if="tableHeadObject.tableColumn5">
					<template #default="scope">
						<div>{{scope.row.create_time}}</div>
						<div>{{scope.row.expiration_time}}</div>
						<el-text type="primary" size="small" v-if="scope.row.remaining_time !==''">{{scope.row.remaining_time}}</el-text>
					</template>
				</el-table-column>
				<el-table-column label="运行状态" v-if="tableHeadObject.tableColumn6">
					<template #default="scope">
						<span class="run-status" v-if="scope.row.status == '运行中'">{{scope.row.status}}</span>
						<span class="try-status" v-else-if="scope.row.status == '创建中'">{{scope.row.status}}</span>
						<span class="stop-status" v-else-if="scope.row.status == '待支付'">{{scope.row.status}}</span>
						<span class="stop-status" v-else-if="scope.row.status == '已过期'">{{scope.row.status}}</span>
						<span class="info-status" v-else>{{scope.row.status}}</span>
					</template>
				</el-table-column>
				<el-table-column label="实例类型" v-if="tableHeadObject.tableColumn7">
					<template #default="scope">
						<el-tag>{{scope.row.instance_type}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="配置信息" v-if="tableHeadObject.tableColumn8">
					<template #default="scope">
						<div>规格：{{scope.row.cpu}}核 {{scope.row.memory}}G</div>
						<div>IOPS：{{scope.row.bandwidth}}</div>
						数据容量：{{scope.row.disks}}G
					</template>
				</el-table-column>
				<el-table-column prop="version"  label="实例版本" v-if="tableHeadObject.tableColumn9" />
				<el-table-column prop="instance_desc" label="实例备注" width="160" show-overflow-tooltip v-if="tableHeadObject.tableColumn10" />
				<el-table-column label="操作" width="150" v-if="tableHeadObject.tableColumn11">
				  <template #default="scope">
					<el-button link type="primary" size="small" v-if="scope.row.status == '运行中'" @click="rowOperation(scope.row,'detail')">详情</el-button>
					<el-button link type="danger" size="small" v-if="scope.row.status == '已过期'" @click="rowOperation(scope.row,'delete')">立即释放</el-button>
					<div v-if="scope.row.status == '运行中'">
						<el-button link type="primary" size="small" @click="rowOperation(scope.row,'upgrade')">升级</el-button>
						<el-button link type="primary" size="small" @click="rowOperation(scope.row,'delay')">续费</el-button>
						<el-dropdown class="dropdown-main" size="small" trigger="click" @command="rowOperationMore($event,scope.row)">
							<span class="el-dropdown-link">更多<el-icon class="el-icon--right"><arrow-down /></el-icon></span>
							<template #dropdown>
								<el-dropdown-menu>
									<el-dropdown-item command="config">参数模板</el-dropdown-item>
									<el-dropdown-item command="start">
										<el-text type="danger" v-if="scope.row.restart_flag == 1">需要重启</el-text>
										<el-text v-else>重启实例</el-text>
									</el-dropdown-item>
									<el-dropdown-item command="import">数据导入</el-dropdown-item>
									<el-dropdown-item command="backup">备份管理</el-dropdown-item>
									<el-dropdown-item command="db">创建DB</el-dropdown-item>
									<el-dropdown-item command="auto">自动续费</el-dropdown-item>
								</el-dropdown-menu>
							</template>
						</el-dropdown>
					</div>
				  </template>
				</el-table-column>
			</el-table>
			<pageList :pagination="pagination" :paginationTotal="paginationTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pageList>
		</div>
		<!-- 自动续费 -->
		<el-dialog width="700" :show-close="false" :close-on-click-modal="false" v-model="dialogAutoVisible" title="自动续费">
			<el-alert title="温馨提示：" type="warning" :closable="false" style="margin-bottom: 20px;">
				<template #default>
					<p>1、设置成功后，系统自动以1个月时长进行续费，并将于次日开始的第一个扣款日进行扣款；</p>
					<p>2、自动续费于产品到期前自然日7天，3天，2天以及到期当天为扣款日；</p>
					<p>3、每天只扣款一次，扣款成功或者4个扣款日都失败当月不再扣费，请保持账户余额充足；</p>
					<p>4、如您在扣款日前人工手动续费，则当月不再自动续费；</p>
					<p>5、自动续费仅支持账户余额扣款，暂不支持代金券扣款。</p>
				</template>
			</el-alert>
			<el-form :label-width="formLabelWidth">
				<el-form-item label="开启自动续费">
					<el-switch v-model="autoStatus" />
				</el-form-item>
				<el-form-item label="续费时长">
					<el-select v-model="autoRenewal">
						<el-option v-for="item in autoRenewalOptions" :key="item.month" :value="item.month" :label="item.text"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="resetAuto">取消</el-button>
					<el-button type="primary" @click="submitAuto">提交</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 创建DB -->
		<el-dialog width="700" :show-close="false" :close-on-click-modal="false" v-model="dialogDBVisible" align-center title="创建DB">
			<el-button type="primary" link @click="dbListF(exampleId)" class="dbList-btn">查看所有DB数据 >>></el-button>
			<el-form :rules="rulesDb" ref="ruleDbRef" :model="dbForm" :label-width="formLabelWidth" style="clear: both;">
				<el-form-item label="DB名称" prop="db_name">
					<el-input v-model="dbForm.db_name" autocomplete="off" placeholder="请输入DB名称" />
				</el-form-item>
				<el-form-item label="支持字符集">
					<el-select v-model="dbForm.db_charset" @change="charsetChange">
						<el-option v-for="item in charsetOptions" :key="item[0]" :value="item[0]" :label="item[0]"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="支持字符编码">
					<el-select v-model="dbForm.db_collation">
						<el-option v-for="item in collationOptions" :key="item" :value="item" :label="item"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="resetDb(ruleDbRef)">取消</el-button>
					<el-button type="primary" @click="submitDb(ruleDbRef)">提交</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- DB列表 -->
		<el-dialog width="700" :close-on-click-modal="false" v-model="dialogDBtableVisible" align-center title="DB列表">
			<ul class="db-list" v-loading="dbloading">
				<li v-for="(item, index) in dbData" :key="index"><em>{{index+1}}</em>{{item}}</li>
			</ul>
		  </el-dialog>
		<!-- 导入 -->
		<el-dialog width="700" :show-close="false" :close-on-click-modal="false" v-model="dialogGroupVisible" align-center title="数据导入">
			<el-alert title='重要提示: 导入内容不得大于10M，且每一条SQL必须为;号和换行结尾(";\n")' type="warning" show-icon :closable="false" style="margin-bottom: 20px;" />
			<el-form ref="ruleFormRef" :model="groupForm" :label-width="formLabelWidth">
				<el-form-item label="目标DB" prop="db_name">
					<el-select v-model="groupForm.db_name">
						<el-option v-for="item in dbOptions" :key="item" :value="item" :label="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="导入方式">
					<el-radio-group v-model="handleWay" @change="wayChange">
						<el-radio label="1" border>SQL语句导入</el-radio>
						<el-radio label="2" border>文件导入</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="上传文件" prop="file" v-if="handleWay == 2">
					<el-upload
						class="upload-demo"
						action=""
						:limit="1"
						:http-request="uploadFile"
						accept=".sql"
					>
						<el-button type="primary">选择文件</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item label="sql语句" prop="sql_text" v-if="handleWay == 1">
					<el-input v-model="groupForm.sql_text" type="textarea" placeholder="每一条SQL必须为;号和换行结尾" :autosize="{ minRows: 4}" />
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="resetForm(ruleFormRef)">取消</el-button>
					<el-button type="primary" :disabled="submitDisabled" @click="submitForm(ruleFormRef)">提交</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- tablehead -->
		<el-dialog width="700" :show-close="false" :close-on-click-modal="false" v-model="dialogtableHeadVisible" title="自定义表头项">
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn1" label="实例ID" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn2" label="实例名称" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn3" label="监控" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn4" label="IP地址" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn5" label="开始时间/结束时间" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn6" label="运行状态" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn7" label="实例类型" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn8" label="配置信息" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn9" label="实例版本" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn10" label="实例备注" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn11" label="操作" size="large" /></div>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="reloadChange">取消</el-button>
					<el-button type="primary" @click="submitSetting">提交</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
	import { ref,reactive,inject,onMounted } from 'vue';
	import {useStore} from 'vuex';
	import { useRouter } from 'vue-router';
	import { Histogram } from '@element-plus/icons-vue'
	import pageList from '../../components/pageList.vue'
	import { fetchList,deleteList,restart,dblist,upload,dataImport,dbCharset,dbCreat,delaySpec,autoRenewalSubmit } from '@/api/host';
	import { ElMessage, ElMessageBox } from 'element-plus';
	import { ArrowDown,CopyDocument } from '@element-plus/icons-vue'
	
	
	const store = useStore()
	const hostDomain = inject('hostDomain');
	const router = useRouter();
	const fullscreenLoading = ref(false);
	const dbloading = ref(true);
	const pagination = reactive({page: 1,size: 15});
	const paginationTotal = ref(0);
	const loading = ref(true);
	const searchInput = ref('');
	const searchStatus = ref('');
	const tableData = ref();
	const exampleId = ref('');
	const dbOptions = ref();
	const handleWay = ref('1');
	const dialogDBtableVisible = ref(false);
	const dbData = ref();
	const dialogDBVisible = ref(false);
	const charsetOptions = ref('');
	const collationOptions = ref('');
	const dialogGroupVisible = ref(false);
	const dialogAutoVisible = ref(false);
	const autoStatus = ref(false);
	const autoRenewal = ref(0);
	const autoRenewalOptions = ref();
	const formLabelWidth = ref('160px')
	const ruleFormRef = ref(null)
	const groupForm = ref({db_name:'',sql_text:'',import_file:''})
	const ruleDbRef = ref(null)
	const dbForm = ref({db_name:'',db_charset:'',db_collation:''})
	const rulesDb = reactive({
		db_name: [
			{ required: true, message: '请填写DB名称', trigger: 'blur' },
		]
	});
	const dialogtableHeadVisible = ref(false);
	const tableHeadObjectDefault = ref({
	  tableColumn1: true,
	  tableColumn2: true,
	  tableColumn3: true,
	  tableColumn4: true,
	  tableColumn5: true,
	  tableColumn6: true,
	  tableColumn7: true,
	  tableColumn8: true,
	  tableColumn9: true,
	  tableColumn10: true,
	  tableColumn11: true
	});
	const tableHeadObject = ref({
	  tableColumn1: true,
	  tableColumn2: true,
	  tableColumn3: true,
	  tableColumn4: true,
	  tableColumn5: true,
	  tableColumn6: true,
	  tableColumn7: true,
	  tableColumn8: true,
	  tableColumn9: true,
	  tableColumn10: true,
	  tableColumn11: true
	});
	
	
	const fetchListF = () => {
		const param = {
			'page':pagination.page,
			'size':pagination.size,
			'search':searchInput.value,
			'status':searchStatus.value
		}
		fetchList(param).then((res) => {
			paginationTotal.value = res.data.total;
			tableData.value = res.data.list;
			loading.value = false;
		})
	};
	const wayChange = (val) => {
		handleWay.value = val
		ruleFormRef.value.clearValidate()
	}
	const uploadFile = (file) => {
		let formData = new FormData();
		const blob = file.file;
		formData.append("file", blob);
		upload(formData).then((res) => {
			groupForm.value.import_file = res.data;
		})
	};
	const rowOperation = (row, now) => {
		exampleId.value = row.instance_id;
		if(now == 'detail'){
			router.push({ path: '/hosts/detail',query: { id: row.instance_id} })
		}
		if(now == 'delay'){
			router.push({ path: '/hosts/delay',query: { id: row.instance_id } })
		}
		if(now == 'upgrade'){
			router.push({ path: '/hosts/upgrade',query: { id: row.instance_id } })
		}
		if(now == 'delete'){
			const param = {"instance_id": row.instance_id}
			ElMessageBox.confirm(
				'确定执行此操作么？',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					showClose:false,
					type: 'warning',
				}
			)
			.then(() => {
				fullscreenLoading.value = true;
				deleteList(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							type: 'success',
							message: res.msg,
						})
						fetchListF()
					}
					fullscreenLoading.value = false;
				})
			})
			.catch(() => {
				
			})
		}
	};
	const rowOperationMore = (now,row) => {
		exampleId.value = row.instance_id;
		if(now == 'config'){
			router.push({ path: '/config',query: { template: row.template_id,example:row.instance_id} })
		}
		if(now == 'backup'){
			router.push({ path: '/backup' })
		}
		if(now == 'import'){
			dialogGroupVisible.value = !dialogGroupVisible.value;
			const param = {"instance_id": row.instance_id};
			dblist(param).then((res) => {
				if(res.code === 200){
					dbOptions.value = res.data.list;
					groupForm.value.db_name = res.data.list[0]
				}
			})
		}
		if(now == 'auto'){
			fullscreenLoading.value = true;
			exampleId.value = row.instance_id;
			const param = {'instance_id':row.instance_id}
			delaySpec(param).then((res) => {
				if (res.code == 200) {
					autoRenewalOptions.value = res.data.list;
					autoStatus.value = row.auto_renewal_months == 0 ? false : true;
					autoRenewal.value = row.auto_renewal_months == 0 ? res.data.list[0].month : row.auto_renewal_months;
					dialogAutoVisible.value = !dialogAutoVisible.value;
				}
				fullscreenLoading.value = false;
			});
		}
		if(now == 'db'){
			dialogDBVisible.value = !dialogDBVisible.value;
			const param = {"instance_id": row.instance_id};
			dbCharset(param).then((res) => {
				if(res.code === 200){
					const transformedData = Object.entries(res.data).reverse();
					charsetOptions.value = transformedData;
					collationOptions.value = transformedData[0][1];
					dbForm.value.db_charset = transformedData[0][0];
					dbForm.value.db_collation = transformedData[0][1][0];
				}
			})
		}
		if(now == 'start'){
			const param = {"instance_id": row.instance_id}
			ElMessageBox.confirm(
				'确认要重启吗？',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					showClose:false,
					type: 'warning',
				}
			)
			.then(() => {
				fullscreenLoading.value = true;
				restart(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							type: 'success',
							message: res.msg,
						})
						fetchListF()
					}
					fullscreenLoading.value = false;
				})
			})
			.catch(() => {
				
			})
		}
	}
	const charsetChange = (val) => {
		const asciiItem = charsetOptions.value.find(item => item[0] === val);
		collationOptions.value = asciiItem[1];
		dbForm.value.db_collation = asciiItem[1][0];
	}
	const dbListF = (id) => {
		dbloading.value = true;
		dialogDBtableVisible.value = !dialogDBtableVisible.value;
		const param = {"instance_id": id};
		dblist(param).then((res) => {
			if(res.code === 200){
				dbData.value = res.data.list;
				dbloading.value = false;
			}
		})
	}
	const submitDb = () => {
		if (!ruleDbRef.value) return;
		ruleDbRef.value.validate((valid) => {
			if (valid) {
				fullscreenLoading.value = true;
				dbForm.value.instance_id = exampleId.value;
				const param = dbForm.value;
				dbCreat(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							offset:70,
							message: res.msg,
							type: 'success'
						})
						resetDb();
						fetchListF();
					}
					fullscreenLoading.value = false;
				})
			} else {
			  return false;
			}
		});
	};
	const resetDb = () => {
		dbForm.value = {db_name:'',db_charset:'',db_collation:''};
		ruleDbRef.value.resetFields();
		dialogDBVisible.value = !dialogDBVisible.value;
	}
	const submitForm = () => {
		fullscreenLoading.value = true;
		groupForm.value.instance_id = exampleId.value;
		const param = groupForm.value;
		dataImport(param).then((res) => {
			if(res.code === 200){
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
				resetForm()
				fetchListF();
			}
			fullscreenLoading.value = false;
		})
	}
	const resetForm = () => {
		groupForm.value = {db_name:'',sql_text:'',import_file:''};
		ruleFormRef.value.clearValidate();
		dialogGroupVisible.value = !dialogGroupVisible.value;
	}
	const submitAuto = () => {
		const param = {'instance_id':exampleId.value};
		param['auto_renewal_months'] = autoStatus.value ? autoRenewal.value : 0;
		autoRenewalSubmit(param).then((res) => {
			if(res.code === 200){
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
				resetAuto();
				fetchListF();
			}
		})
	}
	const resetAuto = () => {
		dialogAutoVisible.value = !dialogAutoVisible.value;
	}
	const handleCurrentChange = (e) => {
		pagination.page = e;
		fetchListF();
	};
	const handleSizeChange = (e) => {
		pagination.size = e;
		fetchListF();
	};
	const searchClick = () => {
		fetchListF();
	};
	const handleEmpty = () => {
		fetchListF();
	};
	const submitSetting = () => {
		localStorage.setItem('rdsThead', JSON.stringify(tableHeadObject.value));
		dialogtableHeadVisible.value = false;
	}
	const reloadChange = () => {
		location.reload()
	}
	
	
	const buyClick = () => {
		window.location.href = hostDomain + "/#/pay";
	};
	onMounted(() => {
		fetchListF()
		tableHeadObject.value = localStorage.getItem('rdsThead') != null ? JSON.parse(localStorage.getItem('rdsThead')) : tableHeadObjectDefault.value;
	})
	
			
</script>

<style lang="scss" scoped>
	.db-list{
		overflow: hidden;
		em{width: 18px;height: 18px; line-height: 18px; display: inline-block; border-radius: 100%;background: #aaa; text-align: center; color: #fff; margin-right: 5px; font-size: 12px;}
		li{float: left; width: 33.3%;line-height: 20px;margin-bottom: 10px;}
	}
	.dbList-btn {line-height: 24px;position: absolute;right: 12px;top: 16px;}
	.upload-demo{width: 60%;}
	.monitor {
	    width: 20px;
	    height: 20px;
	    display: inline-block;
	    position: relative;
	    vertical-align: middle;
	    cursor: pointer;
		background: url(../../assets/images/monitor.png) center no-repeat;
	}
	.monitor:hover {
		background: url(../../assets/images/monitor-h.png) center no-repeat;
	}
</style>